import React from "react";
import { useState } from "react";
import Layout from "../components/Formulario/Layout";
import Register from "../components/Formulario/Register";
import Datos from "../components/Formulario/Datos";
import { useForm } from "react-hook-form";
import signUpService from "../services/signUp";

const Formulario = ({ color = "#0CB9C1", product }) => {
  //F85A40 - GV 0CB9C1-TALENTO  -  F48924-PROFESOR


  const [page, setPage] = useState(1);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({mode: 'all',criteriaMode: 'all', defaultValues: {
    name: '',
    lastName: '',
    email: '',
    pass: '',
    phone: '',
    university: '',
    age: '1999-02-12',
    studyLevel: 'Entre en 1er - 4to semestre',
    startdate: 'En cualquier momento',
    destiny: '3',
    exp: 1,
    referal: '5',
    prom_code: '6',
    lc: '',
    career: '',
    englishLevel: 1,
    proExp: 1,
    subproGt: 'Otro',
    selected_program:product,
    utm_source: ' ',
    utm_medium: ' ',
    utm_campaign: ' ',
    utm_term: ' ',
    utm_content: ' '
  }});

  // const onSubmit = data => console.log(data);
  const onSubmit = data => {
    const prepareData = {};
    for (const [key, value] of Object.entries(data)) {
      console.log(`${key}: ${value}`);
      prepareData[key] = {};
      prepareData[key].value = value;
    }
    signUpService.post(prepareData)
    console.log(prepareData);
  };


  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {page === 1 ? (
        <Layout
          color={color}
          header={{
            text: "Inicia sesión",
            url: "https://auth.aiesec.org/users/sign_in?country=Colombia",
          }}
          title="Registrate 💪"
          button={{ text: "Siguiente", onClick: () => setPage(2) }}
        >
          <Register register={register} errors={errors} />
        </Layout>
      ) : (
        <>
          <Layout
            color={color}
            header={{ text: "2/2", url: "" }}
            title="Unos datos más"
            button={{ text: "Listo!", onClick: () => {} }}
          >
            <p
              className="absolute top-[31px] text-xs text-gray-400"
              onClick={() => setPage(1)}
            >
              {" "}
              &lt; Atras
            </p>
            <Datos register={register} errors={errors} product={product} />
          </Layout>
        </>
      )}
      <input type="submit" />
    </form>
  );
};

export default Formulario;
